import { render } from "./app-content.vue?vue&type=template&id=663a1a56&scoped=true"
import script from "./app-content.vue?vue&type=script&lang=js"
export * from "./app-content.vue?vue&type=script&lang=js"

import "./app-content.vue?vue&type=style&index=0&id=663a1a56&lang=scss&scoped=true"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663a1a56"]])

export default __exports__